'use client';

import { useEffect, useRef, useState } from 'react';

import { VideoCarouselProps } from './types';
import Carousel from '../../carousel/ui/Carousel';

import { VideoPlayer } from '@/shared/components/videoPlayer';
import { SCREEN_SM } from '@/shared/constants/common';

export const VideoCarousel = ({ videos, pagination }: VideoCarouselProps) => {
  const swiperContainerRef = useRef<HTMLDivElement>(null);
  const [isMobile, setIsMobile] = useState<boolean>();

  const onSlideChange = () => {
    if (!swiperContainerRef.current) {
      return;
    }

    const swiperContainerNode = swiperContainerRef.current;

    swiperContainerNode
      .querySelectorAll<HTMLVideoElement>('video')
      .forEach((video) => {
        if (video.paused) {
          return;
        }
        video.pause();
      });
  };

  useEffect(() => {
    if (typeof window === undefined) {
      return;
    }
    const handleResize = () => setIsMobile(window.innerWidth <= SCREEN_SM);

    window.addEventListener('resize', handleResize);

    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div ref={swiperContainerRef} className="w-full">
      <Carousel
        loop
        variant="main"
        spaceBetweenSlides={20}
        navigation={!isMobile}
        pagination={pagination}
        navigationButtonsType="square"
        onSlideChange={onSlideChange}
      >
        {videos.map((video, index) => (
          <Carousel.Item
            key={index}
            className="flex h-full w-full items-center justify-center"
          >
            <div className={'flex h-full w-full items-center justify-center'}>
              <VideoPlayer {...video} />
            </div>
          </Carousel.Item>
        ))}
      </Carousel>
    </div>
  );
};
